import { useEffect, useState } from "react";
import HireNav from "@/components/hire/HireNav";
import HireHero from "@/components/hire/HireHero";
import HireForm from "@/components/hire/HireForm";
import HowItWorks from "@/components/hire/HowItWorks";
import ShortlistPreview from "@/components/hire/ShortlistPreview";
import WhyUs from "@/components/hire/WhyUs";
import Verification from "@/components/hire/Verification";
import GlobalNetwork from "@/components/hire/GlobalNetwork";
import HirePricing from "@/components/hire/HirePricing";
import HireFinalCTA from "@/components/hire/HireFinalCTA";
import HireFooter from "@/components/hire/HireFooter";
import { SEO } from "@/components/hire/content";
import { scrollToId } from "@/components/hire/utils";

export default function Hire() {
    const [packageInterest, setPackageInterest] = useState(null);

    useEffect(() => {
        const prevTitle = document.title;
        document.title = SEO.title;
        const tags = {
            'meta[name="description"]': SEO.description,
            'meta[property="og:title"]': SEO.title,
            'meta[property="og:description"]': SEO.description,
            'meta[property="og:image"]': SEO.image,
            'meta[property="og:url"]': SEO.url,
            'meta[name="twitter:title"]': SEO.title,
            'meta[name="twitter:description"]': SEO.description,
            'meta[name="twitter:image"]': SEO.image,
        };
        const prev = Object.entries(tags).map(([sel, val]) => {
            const el = document.querySelector(sel);
            const old = el?.getAttribute("content");
            el?.setAttribute("content", val);
            return [el, old];
        });
        return () => {
            document.title = prevTitle;
            prev.forEach(([el, old]) => old != null && el?.setAttribute("content", old));
        };
    }, []);

    const choosePackage = (pkg) => {
        setPackageInterest({ name: pkg, nonce: Date.now() });
        scrollToId("hire-form");
    };

    return (
        <main className="hire-root relative overflow-x-clip bg-white text-hire-ink">
            <HireNav />
            <HireHero />
            <HowItWorks />
            <ShortlistPreview />
            <WhyUs />
            <Verification />
            <GlobalNetwork />
            <HirePricing onSelect={choosePackage} />
            <HireForm preselectedPackage={packageInterest} />
            <HireFinalCTA />
            <HireFooter />
        </main>
    );
}
